import { deepMerge } from 'src/libs/qb-brand-web-components'

import defaultConfig from '../common/customConfig'

const customConfig = {
  howManyPointsYouEarnLabel: 'brand:reward.how-many-points-you-earn'
}

export default deepMerge(defaultConfig, customConfig)
